import { defaultCurrency, projectDomainName } from 'shared/constants'

export const bonuses = {
  wonBonus: 'Won bonus',
  bonuses: 'Bonuses',
  moreAboutStock: 'More about the stock',
  bonusHistory: 'Bonus History',
  gettingToCashback: 'Getting to cashback',

  ALL: 'All',
  Cashback: 'Cashback',
  SportDiscount: 'Sport discount',
  FirstDeposit: 'First deposit',
  DetractedFirstDepositBonusByWithdrawal: 'Detracted first deposit bonus by withdrawal',
  IncreasedBySO: 'Increased by SO',
  TransferBonusesToBalance: 'Transfer bonuses to balance',
  LuckySpin: 'Lucky spin',
  PromotionToRealBalance: 'Paid',
  balanceConvertedSuccess: 'Balance added successfully',
  exchange: 'Exchange',
  enterAmount: 'Enter the amount',
  bonusBalanceOnYourAccount: 'Your current bonus balance',
  exchangeRate: 'Exchange rate',
  min: 'Min',
  half: '1/2',
  x2: 'x2',
  max: 'Max',
  clear: 'Clear',
  balanceMustBeLess: 'Balance must be less than',
  toCompleteExchange: 'to complete the exchange',
  amount: 'Amount',
  bonusAmount: 'Bonus amount',

  DecreasedByOwner: 'Withdraw',
  IncreasedByOwner: 'Deposit',
  PersonalJackpot: 'Personal jackpot',

  activate: 'Activate',
  bonus: 'Bonus',
  freeSpins: 'Free spins',
  status: 'Status',
  expirationDate: 'Expiration date',
  wager: 'Need to win back',
  wagerComplete: 'Won back',
  AVAILABLE: 'Available',
  AVAILABLE_COMPLETED: 'Available',
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
  COMPLETED: 'In wagering',
  PAID: 'Paid',
  WAIT: 'Wait',
  successActivate: 'Successfully activated',
  cancelBonus: 'You canceled the bonus',
  noBonuses: "You don't have bonuses",
  changeActiveBonusText: `When a new bonus is activated, the bonus will be suspended.
  The stopped bonus can be activated again.`,
  cancel: 'Cancel',
  freeSpinsGames: 'Free spins games',
  winAfterWagering: 'Win after wagering',
  first_deposit_bonus: 'Bonus',
  first_deposit_freespins: 'Free spin bonus',
  every_deposit_bonus: 'Bonus',
  bonusTransfer: `Balance must no less then $balance ${defaultCurrency} to complete the change`,
  wagerCoef: 'Wager',
  validityTerm: 'Validity term',
  day: 'D',
  freeSpinBonus: 'Free spin bonus',
  bonusWheel: 'Bonus wheel',
  bonusBackCardInfo:
    `In ${projectDomainName} A 300% First Deposit Bonus is available
     for all new Players on a permanent basis. The first deposit
      bonus applies only to the Player's first deposit, it is equal to 300% of the amount of the first deposit.\n` +
    `Bonus money – rewards equivalent to real money that the user receives from the
     casino on a free and gratuitous basis. When requesting a withdrawal
      of funds, the non-wagered bonus on the first deposit is canceled.`,
  freeSpinBackCardInfo: `In our casino, each new player can get a certain number
   of free spins when registering. Free spin is a spin in slots when no money is deducted 
   from the player's balance. When you register, you get 130 free free spins! The specified 
   bonus is given only once – directly for registration to new players who do not have other accounts
    in the casino ${projectDomainName}`,
  youWonJackpot: 'You have won the jackpot!',
  firstDepositNotify: 'You have received first deposit in the amount of',
  cashbackNotify: 'You have received cashback in the amount of',
  pickUp: 'Pick Up',
  receive: 'Receive',
  collectWinnings: 'Collect winnings',
  moneySuccessfully: 'Money added successfully',
  yourFirstDeposit: 'Your first deposit',
  yourCashback: 'Your cashback',
  yourJackpot: 'Your jackpot',
  ok: 'OK',
  youGot: 'You got',

  openGames: 'Open games',
  wagerFreeSpinsCoef: 'Roll-over',
  wagerFreeSpinsComplete: 'Conquest',
  needToFreeSpinsWinBack: 'Meta roll-over',
  needToWinBack: 'Need to win back',
  days: 'Days',
  attention: 'Attention',
  back: 'Back',
  clickForPlayFreeSpins: 'Click for play free spins!',
  wagerText: 'Take advantage of your bonus to play and reach the goal of',
  takeYourBonus: 'Take your bonus',
  confirmActivateBonus: 'Confirm activate bonus',
  freeSpinEnd: 'Spins are over',
  freeSpinEndText: 'The free spins are over',
  promotions: 'Promotions',
}
